import axios from 'axios'

const api = axios.create({
  withCredentials: true,
})

// Methods that read but do not change anything. A 401 on one of these can be recovered by
// bouncing through SSO, because there is no unsaved user input to lose.
const SAFE_METHODS = ['get', 'head', 'options']

const buildLoginUrl = () => {
  const returnUrl = `${window.location.pathname}${window.location.search}`
  return `/login?returnUrl=${encodeURIComponent(returnUrl)}`
}

// Handle 401 (expired session). The backend answers API calls with a status code rather than a
// redirect -- see Ditto.Api.Extensions.CookieAuthenticationExtensions -- so this is a real
// response, not the cross-origin redirect failure that used to surface as "Network error".
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      const method = (error.config?.method || 'get').toLowerCase()

      if (SAFE_METHODS.includes(method)) {
        console.warn('Session expired on a read - redirecting to login')
        window.location.href = buildLoginUrl()
      } else {
        // Navigating away here would discard whatever the user was writing (a half-authored
        // lesson, for example), so surface it and let them sign in without losing the form.
        error.sessionExpired = true
        console.warn('Session expired on a write - surfacing to the caller')
      }
    }

    return Promise.reject(error)
  }
)

export const getLogs = async (limit = 100, days = 90) => {
  const response = await api.get('/api/logs', {
    params: { limit, days }
  })
  return response.data
}

export default api
